import { apis, RequestOptions } from "../../backend";
import Contact from "../../models/Contact";
import ContactQuery from "../../models/ContactQuery";
import { ContactUpdateRecord } from "../../models/ContactUpdateRecord";

/**
 * Fetches a specific contact.
 */
export async function getContact(contactId: string): Promise<Contact> {
  const contact = await apis.contacts.get<Contact>(`/contacts-v1/${contactId}`);
  return new Contact(contact);
}

/**
 * Fetches contacts.
 */
export async function listContacts(query: ContactQuery, opts?: RequestOptions): Promise<Contact[]> {
  const contacts = await apis.contacts.get('/contacts-v1', {
    ...(query || {}),
    ...(query.sort?.toQuery() || {}),
    sort: undefined,
    s: query.search,
  }, opts);

  return contacts.map((contact: Partial<Contact>) => new Contact(contact));
}

/**
 * Returns a list of contact IDs, given a query.
 */
export async function listContactIds(query: ContactQuery): Promise<string[]> {
  return await apis.contacts.get('/contact-information-v1/id', {
    ...(query || {}),
    ...(query.sort?.toQuery() || {}),
    sort: undefined,
    s: query.search,
  });
}

/**
 * Counts contacts.
 */
export async function countContacts(query: ContactQuery): Promise<number> {
  const { count } = await apis.contacts.get('/contacts-v1/count', {
    ...(query || {}),
    ...(query.sort?.toQuery() || {}),
    sort: undefined,
    s: query.search,
  });

  return count;
}

/**
 * Deletes several contacts.
 */
export async function deleteContacts(contactIds: string[]) {
  await apis.contacts.del(`/contacts-v1`, { contactIds: contactIds.join(',') });
}

export async function listContactUpdates(contactId: string, opts: RequestOptions = {}): Promise<ContactUpdateRecord[]> {
  const records = await apis.contacts.get<ContactUpdateRecord[]>(`/contact-updates-v1/${contactId}`, null, opts);

  return records.map(record => new ContactUpdateRecord(record));
}